/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { resBreak } from '@/utils/resBreak';
import { SxProps } from '@mui/material/styles';

export const facetNavigationAccordionSummarySX: SxProps = {
	p: { md: 1 },
	pl: { md: 2 },
	'&[role="button"]:hover': {
		cursor: { md: 'default' },
	},
	mt:resBreak<'margin'>({mobile:0, tablet:2, desktop:2})
};
